import { useEffect, useMemo, useState } from "react";
import { MainLayout, SectionLayout } from "../layouts";
import { useLocation } from "react-router-dom";
import * as FaIcons from "react-icons/fa";
import { fetcher } from "../Func/Fetcher";
import BannerPage from "../components/BannerPage";

// Warna brand per platform, dicocokkan lewat field `medsos` dari API
const BRAND_COLORS = {
  Telegram: "bg-sky-500",
  Facebook: "bg-blue-600",
  WhatsApp: "bg-green-500",
  Instagram: "bg-gradient-to-tr from-yellow-400 via-pink-500 to-purple-600",
};

const DEFAULT_COLOR = "bg-idi-600";

// Ambil username/handle dari URL untuk ditampilkan (buang query string & trailing slash)
const getDisplayValue = (url, medsos) => {
  try {
    const parsed = new URL(url);
    const lastSegment = parsed.pathname.replace(/\/$/, "").split("/").pop();

    if (medsos === "WhatsApp") {
      // Format nomor: 628112347885 -> +62 811-2347-885
      const digits = lastSegment.replace(/\D/g, "");
      if (digits.startsWith("62")) {
        const rest = digits.slice(2);
        return `+62 ${rest.slice(0, 3)}-${rest.slice(3, 7)}-${rest.slice(7)}`;
      }
      return lastSegment;
    }

    return lastSegment.startsWith("@") ? lastSegment : `@${lastSegment}`;
  } catch (e) {
    return url;
  }
};

export default function HubungiKami() {
  const location = useLocation();
  const [data, setData] = useState([]);
  // const { data } = useGetDataFromApi("medsos/0");
  useEffect(() => {
    const fetch = async () => {
      const response = await fetcher.GET("/getMedsos/0/0/0");
      const res = response.success ? response.data : [];
      setData(res);
    };
    fetch();
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [location.pathname]);

  const socialLinks = useMemo(() => {
    if (!data) return [];
    const actualData = data.data || data;
    return Array.isArray(actualData) ? actualData : [];
  }, [data]);

  return (
    <MainLayout title="Hubungi Kami - MA Idrisiyyah">
      <BannerPage
        title="Hubungi Kami"
        subtitle="Kami siap membantu dan menjawab pertanyaan Anda"
      />

      <SectionLayout title="Hubungi Kami">
        <div className="max-w-5xl mx-auto">
          {/* Social / Contact Cards */}
          {socialLinks.length > 0 && (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-14">
              {socialLinks.map((item) => {
                const IconComponent = FaIcons[item.icon];
                const colorClass = BRAND_COLORS[item.medsos] || DEFAULT_COLOR;

                return (
                  <a
                    key={item.id}
                    href={item.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="group bg-white dark:bg-neutral-800 rounded-2xl border border-neutral-100 dark:border-neutral-700 shadow-sm hover:shadow-md p-6 flex flex-col items-center text-center gap-4 transition-all duration-300 hover:-translate-y-1"
                  >
                    <div
                      className={`w-14 h-14 rounded-full flex items-center justify-center text-white ${colorClass} group-hover:scale-110 transition-transform duration-300`}
                    >
                      {IconComponent ? (
                        <IconComponent className="w-7 h-7" />
                      ) : (
                        <span className="text-xs font-bold">
                          {item.medsos?.charAt(0)}
                        </span>
                      )}
                    </div>
                    <div>
                      <h3 className="font-bold text-neutral-800 dark:text-neutral-100">
                        {item.medsos}
                      </h3>
                      <p className="text-sm text-neutral-500 dark:text-neutral-400 mt-1 break-all">
                        {getDisplayValue(item.url, item.medsos)}
                      </p>
                    </div>
                  </a>
                );
              })}
            </div>
          )}

          {/* Address & Map */}
          <div className="grid grid-cols-1 lg:grid-cols-5 gap-8">
            <div className="lg:col-span-2 bg-white dark:bg-neutral-800 rounded-2xl border border-neutral-100 dark:border-neutral-700 shadow-sm p-8 flex flex-col justify-center gap-6">
              <div className="flex gap-4">
                <div className="flex-shrink-0 w-10 h-10 rounded-full bg-idi-100 dark:bg-idi-900/30 text-idi-600 dark:text-idi-400 flex items-center justify-center">
                  <svg
                    className="w-5 h-5"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M17.657 16.657L13.414 20.9a2 2 0 01-2.828 0l-4.243-4.243a8 8 0 1111.314 0z"
                    ></path>
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                    ></path>
                  </svg>
                </div>
                <div>
                  <h3 className="font-bold text-neutral-800 dark:text-neutral-100 mb-1">
                    Alamat
                  </h3>
                  <p className="text-sm text-neutral-500 dark:text-neutral-400 leading-relaxed">
                    Pondok Pesantren Idrisiyyah, Kec. Pageurageung, Kabupaten
                    Tasikmalaya, Jawa Barat, Indonesia
                  </p>
                </div>
              </div>

              {socialLinks.find((item) => item.medsos === "WhatsApp") && (
                <div className="flex gap-4">
                  <div className="flex-shrink-0 w-10 h-10 rounded-full bg-idi-100 dark:bg-idi-900/30 text-idi-600 dark:text-idi-400 flex items-center justify-center">
                    <svg
                      className="w-5 h-5"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                      ></path>
                    </svg>
                  </div>
                  <div>
                    <h3 className="font-bold text-neutral-800 dark:text-neutral-100 mb-1">
                      WhatsApp
                    </h3>
                    {(() => {
                      const wa = socialLinks.find(
                        (item) => item.medsos === "WhatsApp",
                      );
                      return (
                        <a
                          href={wa.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-sm text-idi-600 dark:text-idi-400 hover:underline"
                        >
                          {getDisplayValue(wa.url, "WhatsApp")}
                        </a>
                      );
                    })()}
                  </div>
                </div>
              )}
            </div>

            <div className="lg:col-span-3 w-full rounded-2xl overflow-hidden border border-neutral-100 dark:border-neutral-700 shadow-sm h-[300px] lg:h-auto">
              <iframe
                title="pesantren-idrisiyyah-map"
                src="https://www.google.com/maps?q=-7.2656774,108.1855607&hl=id&z=17&output=embed"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
        </div>
      </SectionLayout>
    </MainLayout>
  );
}
